import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { decodeToken, isTokenExpired } from './utils/jwt';
import { useDarkMode } from './DarkModeContext';

const BOUKAR_USER_ID = '673247877e4ac0a824cbac0d';

/** Posters in `public/posters/`, excluding `eye-icon.PNG`, sorted for a stable grid. */
const POSTER_FILES = [
    'canoicacn.jpeg',
    'fzdcz.jpeg',
    'vdznoi.jpeg',
    'vnzdio.jpeg',
    'vozj.jpeg',
    'vznoi.jpeg',
    'vvnzoi.jpeg',
    'znvodi.jpeg',
];

const MOCK_VIEW_LABELS = ['12M', '1.5M', '9,411', '7,243', '2.3M', '892K', '156K', '4.1M'];

export default function PostersCoversPage() {
    const navigate = useNavigate();
    const { darkMode } = useDarkMode();
    const [allowed, setAllowed] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token || isTokenExpired(token)) {
            navigate('/', { replace: true });
            return;
        }
        const decoded = decodeToken(token);
        const id = decoded?.userId != null ? String(decoded.userId) : '';
        if (id !== BOUKAR_USER_ID) {
            navigate('/workspace', { replace: true });
            return;
        }
        setAllowed(true);
    }, [navigate]);

    if (!allowed) {
        return (
            <div
                style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: darkMode ? '#0f0f10' : '#f0f0f2',
                    color: darkMode ? '#e4e4e7' : '#27272a',
                }}
            >
                Loading…
            </div>
        );
    }

    const bg = darkMode ? '#0f0f10' : '#f0f0f2';
    const text = darkMode ? '#fafafa' : '#18181b';
    const sub = darkMode ? '#a1a1aa' : '#52525b';
    const btnBg = darkMode ? '#27272a' : '#fff';
    const btnBorder = darkMode ? '1px solid #3f3f46' : '1px solid #d4d4d8';

    return (
        <div style={{ minHeight: '100vh', backgroundColor: bg, color: text }}>
            <header
                style={{
                    padding: '16px 20px',
                    borderBottom: darkMode ? '1px solid #27272a' : '1px solid #e4e4e7',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                }}
            >
                <button
                    type="button"
                    onClick={() => navigate('/workspace')}
                    style={{
                        padding: '10px 18px',
                        borderRadius: '8px',
                        border: btnBorder,
                        backgroundColor: btnBg,
                        color: text,
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: 600,
                    }}
                >
                    Back to workspace
                </button>
                <span style={{ fontSize: '14px', color: sub }}>Covers (preview)</span>
            </header>

            <main
                style={{
                    width: '100%',
                    padding: 0,
                    margin: 0,
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                    gap: '1px',
                }}
            >
                {POSTER_FILES.map((file, i) => (
                    <div
                        key={file}
                        style={{
                            position: 'relative',
                            borderRadius: 0,
                            overflow: 'hidden',
                            aspectRatio: '9 / 16',
                            backgroundColor: darkMode ? '#18181b' : '#e4e4e7',
                            boxShadow: 'none',
                        }}
                    >
                        <img
                            src={`/posters/${file}`}
                            alt=""
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                        <div
                            style={{
                                position: 'absolute',
                                left: -5,
                                bottom: -5,
                                right: 'auto',
                                maxWidth: 'calc(100% - 8px)',
                                padding: '4px 8px 4px 5px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '2px',
                            }}
                        >
                            <img
                                src="/posters/eye-icon.PNG"
                                alt=""
                                style={{
                                    width: 30,
                                    height: 30,
                                    objectFit: 'contain',
                                    flexShrink: 0,
                                    filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.75))',
                                }}
                            />
                            <span
                                style={{
                                    fontSize: '16px',
                                    fontWeight: 700,
                                    color: '#fff',
                                    textShadow: '0 1px 2px rgba(0,0,0,0.85)',
                                    letterSpacing: '0.02em',
                                }}
                            >
                                {MOCK_VIEW_LABELS[i] ?? '—'}
                            </span>
                        </div>
                    </div>
                ))}
            </main>
        </div>
    );
}
